<div class="message-view" *ngIf="message; else emptyState">
  <div class="message-header">
    <!-- las marcas de respondido y reenviado van aqui, pegadas a la derecha del asunto: son estado del mensaje y
         no acciones, asi que no tienen que competir por sitio con la barra de botones -->
    <div class="message-subject-row">
      <h3 class="message-subject-title">{{message.subject || '(sin asunto)'}}</h3>

      <div class="message-subject-tags">
        <p-tag *ngIf="message.answered" icon="pi pi-reply" value="Respondido" severity="info"
               pTooltip="Este mensaje ya tiene respuesta"></p-tag>

        <p-tag *ngIf="message.forwarded" icon="pi pi-arrow-up-right" value="Reenviado" severity="info"
               pTooltip="Este mensaje ya se ha reenviado"></p-tag>
      </div>
    </div>

    <!-- rejilla de dos columnas, no una fila flex por linea: asi la columna de etiquetas se ajusta sola a la mas
         larga y todas ocupan lo mismo, con los valores alineados. Sin anchos puestos a ojo.
         El remitente entra en la MISMA rejilla para que su "De:" mida igual que "Para:". -->
    <div class="message-addresses">
      <span class="text-color-secondary message-label">De:</span>
      <span class="message-recipients flex align-items-baseline gap-2 flex-wrap">
        <span class="font-semibold">{{senderLabel()}}</span>
        <span *ngIf="message.from?.address" class="text-color-secondary">&lt;{{message.from?.address}}&gt;</span>
        <span class="text-color-secondary ml-auto message-label">{{message.date | date:'dd/MM/yyyy HH:mm'}}</span>
      </span>

      <span class="text-color-secondary message-label">Para:</span>
      <span class="message-recipients">{{addressList(message.to) || '(sin destinatarios)'}}</span>

      <ng-container *ngIf="message.cc.length > 0">
        <span class="text-color-secondary message-label">CC:</span>
        <span class="message-recipients">{{addressList(message.cc)}}</span>
      </ng-container>

      <!-- CCO y Responder a casi nunca vienen en un correo recibido, pero cuando vienen son informacion que no se
           debe perder: se muestran igual que el resto, no escondidos -->
      <ng-container *ngIf="message.bcc.length > 0">
        <span class="text-color-secondary message-label">CCO:</span>
        <span class="message-recipients">{{addressList(message.bcc)}}</span>
      </ng-container>

      <ng-container *ngIf="message.replyTo.length > 0">
        <span class="text-color-secondary message-label">Responder a:</span>
        <span class="message-recipients">{{addressList(message.replyTo)}}</span>
      </ng-container>
    </div>

    <div class="flex align-items-center gap-2 flex-wrap message-toolbar">
      <p-button icon="pi pi-reply" label="Responder" size="small" severity="secondary"
                [disabled]="!allowSend" (click)="composeRequested.emit('reply')"></p-button>

      <p-button icon="pi pi-users" label="Responder a todos" size="small" [outlined]="true" severity="secondary"
                [disabled]="!allowSend" (click)="composeRequested.emit('replyAll')"></p-button>

      <p-button icon="pi pi-arrow-up-right" label="Reenviar" size="small" [outlined]="true" severity="secondary"
                [disabled]="!allowSend" (click)="composeRequested.emit('forward')"></p-button>

      <span class="message-toolbar-separator"></span>

      <p-button [icon]="message.seen ? 'pi pi-envelope' : 'pi pi-check'"
                [label]="message.seen ? 'No leído' : 'Leído'"
                size="small" [outlined]="true" severity="secondary"
                (click)="toggleSeen.emit()"></p-button>

      <p-button [icon]="message.flagged ? 'pi pi-star-fill' : 'pi pi-star'"
                label="Destacar" size="small" [outlined]="true" severity="secondary"
                [disabled]="!allowManage" (click)="toggleFlagged.emit()"></p-button>

      <p-button icon="pi pi-folder-open" label="Mover a" size="small" [outlined]="true" severity="secondary"
                [disabled]="!allowManage || moveMenu.length === 0"
                (click)="moveTargetsMenu.toggle($event)"></p-button>
      <p-tieredMenu #moveTargetsMenu [model]="moveMenu" [popup]="true" appendTo="body"></p-tieredMenu>

      <p-tag *ngIf="message.hasCalendar" value="Incluye una invitación de calendario" severity="info"></p-tag>

      <div class="flex-grow-1"></div>

      <!-- a la derecha y solo con icono: son las dos acciones que menos se usan y no necesitan etiqueta -->
      <a *ngIf="sourceUrl" pButton [href]="sourceUrl" target="_blank" rel="noopener"
         icon="pi pi-download" size="small" [outlined]="true" severity="secondary"
         pTooltip="Descargar el mensaje original (.eml)"></a>

      <p-button icon="pi pi-trash" size="small" [outlined]="true" severity="danger"
                pTooltip="Enviar a la papelera"
                [disabled]="!allowManage" (click)="deleteRequested.emit()"></p-button>
    </div>
  </div>

  <!-- solo esta zona desplaza: la ficha del mensaje (asunto, remitente, destinatarios y acciones) se queda fija
       arriba, para no perderla de vista al recorrer una cadena larga de respuestas -->
  <div class="message-content">

    <!-- los adjuntos van ANTES del cuerpo: son lo primero que se busca al abrir un correo, y dejarlos al final
         obligaba a recorrer todo el mensaje para llegar a ellos -->
    <div *ngIf="message.attachments.length > 0" class="message-attachments">
      <div class="text-color-secondary mb-2">
        <i class="pi pi-paperclip mr-1"></i>
        {{message.attachments.length}} {{message.attachments.length === 1 ? 'adjunto' : 'adjuntos'}}
      </div>
      <div class="flex flex-wrap gap-2">
        <a *ngFor="let attachment of message.attachments" class="attachment-chip"
           (click)="attachmentRequested.emit(attachment)">
          <i [class]="iconFor(attachment.contentType)"></i>
          <span class="attachment-name">{{attachment.fileName}}</span>
          <span class="text-color-secondary">{{sizeLabel(attachment.size)}}</span>
        </a>
      </div>
    </div>

    <app-message-body class="message-body-host"
                      [bodyDocument]="bodyDocument"
                      [bodyUrl]="bodyUrl"
                      [blockedImageCount]="message.blockedImageCount"
                      [allowRemoteImages]="allowRemoteImages"
                      (allowRemoteImagesChange)="allowRemoteImagesChange.emit($event)"></app-message-body>
  </div>
</div>

<ng-template #emptyState>
  <div class="empty-state" *ngIf="!loading">
    <i class="pi pi-envelope"></i>
    <div>Selecciona un mensaje para leerlo.</div>
  </div>
  <div class="empty-state" *ngIf="loading">
    <p-progressSpinner [style]="{width: '32px', height: '32px'}" strokeWidth="4"></p-progressSpinner>
  </div>
</ng-template>
